const defaultWindow = {}

const getWindow = () => (typeof window === 'undefined' ? defaultWindow : window)

export default getWindow
